module.exports = __webpack_public_path__ + "img/zelda-min.9f85683d.png";